/* global window */
import { useDispatch } from 'react-redux';

import { getCart, showSideCart } from 'redux/cart/actions';

const JSWidgets = () => {
  const dispatch = useDispatch();

  window.c7action = {};

  window.c7action.showSideCart = () => {
    dispatch(showSideCart());
  };

  window.c7action.reloadCart = () => {
    dispatch(getCart());
  };
};

export default JSWidgets;
